/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useCallback, useState } from "react";
import { Icon } from "@ddm-design-system/icon";
import { Description } from "@ddm-design-system/typography";
import { LinkButton, PrimaryButton, SecondaryButton } from "@ddm-design-system/button";
import { useDispatch } from "react-redux";
import { ECleaningUnitButtons, IControlUnit } from "../../../../store/installation/types";
import { requestButtonPress } from "../../../../store/installation/actions";
import useContent from "../../../../hooks/useContent";

export interface ISoftWaterNotDetectedProps {
  controlUnit: IControlUnit;
}

const SoftWaterNotDetected: React.FC<ISoftWaterNotDetectedProps> = ({ controlUnit }) => {
  const { managerAppControlUnit: content, managerAppCommon } = useContent();
  const { id } = controlUnit;
  const dispatch = useDispatch();
  const [loadingButtonPress, setLoadingButtonPress] = useState(false);

  const handleClear = useCallback(() => {
    setLoadingButtonPress(true);
    dispatch(
      requestButtonPress({
        button: ECleaningUnitButtons.CLEAR_SOFT,
        controlUnitId: controlUnit.id
      })
    );
  }, [controlUnit.id, dispatch]);

  return (
    <div className="cuf-info">
      <input type="checkbox" id={id} className="hidden-checkbox" />
      <div className="cuf-info-wrapper cuf-step-common">
        <div className="cuf-content centered">
          <Icon name="Warn" size={48} color="var(--color-warning-warning100)" />
          <Description>{content.manager_app_cu_step_soft_water_not_detected_desc}</Description>
        </div>
        <label className="label-for" htmlFor={id}>
          <LinkButton className="pointless-button" icon="ChevronDown">
            {managerAppCommon.know_more}
          </LinkButton>
        </label>
      </div>
      <div className="cuf-info-wrapper cuf-step-common">
        <div className="cuf-content centered">
          <Description>{content.manager_app_cu_step_soft_water_not_detected_info}</Description>
        </div>
        <div className="cuf-actions">
          <label className="label-for" htmlFor={id}>
            <SecondaryButton className="pointless-button">
              {managerAppCommon.common_cancel}
            </SecondaryButton>
          </label>
          <PrimaryButton disabled={loadingButtonPress} onClick={handleClear}>
            {managerAppCommon.common_clear}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default SoftWaterNotDetected;
